import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import { PortalSectionTab } from 'playup-web-core';

import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import LimitsHistory from './LimitsHistory';
import Limit from './Limit';

const Limits = () => {
	const { user, refreshPortalUser } = React.useContext(PortalSessionContext);
	const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

	React.useEffect(refreshPortalUser, [refreshPortalUser]);

	const {
		tabs,
		selectedLimit,
		showHistory,
	}: { tabs: Array<string>; selectedLimit: PortalLimit | undefined; showHistory: boolean } = React.useMemo(() => {
		const availableLimits = user?.locale?.available_limits ?? [];
		const tabs = availableLimits.map((availableLimit) => `${availableLimit.name} Limits`);

		tabs.push('Limits History');

		const selectedLimit = availableLimits[selectedTabIndex];

		const showHistory = !selectedLimit;

		return { tabs, selectedLimit, showHistory };
	}, [selectedTabIndex, user?.locale?.available_limits]);

	return (
		<>
			<Helmet title="Limits" />
			<TopWrapper>
				{tabs.length > 1 && (
					<PortalSectionTab
						isSmall={false}
						category={tabs[selectedTabIndex]}
						setCategory={(category) => {
							setSelectedTabIndex(tabs.findIndex((tab) => tab === category));
						}}
						tabs={tabs.map((tab) => ({
							label: tab,
						}))}
					/>
				)}
			</TopWrapper>

			{selectedLimit && (
				<Limit
					selectedLimit={selectedLimit}
					userLimits={user?.limits}
					userLimitsRequests={user?.limit_requests}
					afterSubmit={refreshPortalUser}
				/>
			)}

			{showHistory && <LimitsHistory />}
		</>
	);
};

export default Limits;

const TopWrapper = styled.div`
	margin: 10px 0;
`;
